<template>
  <div>
    <div
      class="p-8 -mx-8 sm:mx-0 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6 border border-gray-100 shadow-lg rounded-lg"
    >
      <div class="sm:col-span-4 text-xl">Grundlegende Informationen</div>

      <basic-input
        class="sm:col-span-6 md:col-span-4"
        label="Veranstaltungstitel"
        placeholder="Veranstaltungstitel"
        v-model="event.title"
        :error="errors['title']"
      />

      <venue-select
        class="sm:col-span-6 md:col-span-4"
        :value="event.venue"
        @input="event.venue_id = $event"
      />

      <basic-date-picker
        label="Veranstaltungsbeginn"
        class="sm:col-span-3"
        v-model="event.start_date.utc"
        :error="errors['start_date.utc']"
        :disabled="!isDraft"
      />

      <basic-date-picker
        label="Veranstaltungsende"
        class="sm:col-span-3"
        v-model="event.end_date.utc"
        :error="errors['end_date.utc']"
        :disabled="!isDraft"
      />

      <basic-input
        class="sm:col-span-3 hidden"
        placeholder="z.B. Einlass 30 Minuten vor Beginn"
        label="Einlassinformationen"
      />
    </div>

    <div
      class="mt-8 p-8 -mx-8 sm:mx-0 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6 border border-gray-100 shadow-lg rounded-lg"
    >
      <div class="sm:col-span-4 text-xl">Details</div>

      <genre-select
        class="sm:col-span-3"
        label="Kategorie"
        v-model="event.genre_id"
        :error="errors['genre_id']"
      />

      <genre-select
        class="sm:col-span-3"
        label="Unterkategorie"
        v-model="event.subgenre_id"
        :error="errors['subgenre_id']"
        corner-hint="Optional"
      />

      <div class="sm:col-span-6">
        <label class="mb-2 block text-sm font-medium leading-5 text-gray-700">Beschreibung</label>
        <VueTrix v-model="event.description" />
      </div>
    </div>

    <div class="mt-8 p-8 -mx-8 sm:mx-0 border border-gray-100 shadow-lg rounded-lg">
      <prices :event="event" :errors="errors" />
    </div>

    <div
      class="mt-8 p-8 -mx-8 sm:mx-0 grid grid-cols-1 sm:grid-cols-6 row-gap-6 col-gap-4 border border-gray-100 shadow-lg rounded-lg"
    >
      <div class="sm:col-span-8 text-xl">Medien</div>
      <div class="sm:col-span-2">
        <basic-image-cropper
          ref="cropperLogo"
          class="sm:col-span-2"
          label="Veranstaltungsbild"
          force-size="600,400"
          :value="event.media.logo"
          @input="event.logo_id = $event"
          :error="errors['logo_id']"
        />

        <basic-button @click="randomPicture" leading-icon="image" color="white" class="mt-4"
          >Zufälliges Foto benutzen</basic-button
        >
      </div>
    </div>

    <div
      v-if="['28675', '28524'].includes($route.params.organizer)"
      class="mt-8 p-8 -mx-8 sm:mx-0 grid grid-cols-1 sm:grid-cols-6 row-gap-6 col-gap-4 border border-gray-100 shadow-lg rounded-lg"
    >
      <div class="sm:col-span-4 text-xl">Technische Felder</div>

      <basic-input
        class="sm:col-span-6 md:col-span-4"
        label="Info, wenn Verkauf gestoppt"
        v-model="event.no_types_info_message"
        :error="errors['no_types_info_message']"
      />
    </div>
  </div>
</template>

<script>
import VueTrix from 'vue-trix';
import BasicDatePicker from '@/components/basic/DatePicker';
import VenueSelect from '@/components/VenueSelect';
import BasicImageCropper from '@/components/basic/ImageCropper';
import BasicPopover from '@/components/basic/Popover';
import Prices from '@/components/editor/Prices';
import GenreSelect from '@/components/GenreSelect';

export default {
  props: {
    isDraft: {
      default: true,
    },
    errors: {
      type: Object,
      default: () => {
        return {};
      },
    },
    event: {
      type: Object,
      required: true,
    },
  },

  components: {
    BasicDatePicker,
    VenueSelect,
    VueTrix,
    BasicImageCropper,
    BasicPopover,
    Prices,
    GenreSelect,
  },

  watch: {
    // Must be function () because we access this
    'event.start_date.utc': function (newVal) {
      this.event.end_date.utc = newVal;
    },
  },

  methods: {
    randomPicture() {
      let url = `https://picsum.photos/seed/${Math.random()
        .toString(36)
        .substring(2, 15)}/1440/450`;

      this.$refs.cropperLogo.loadImage(url);
    },
  },
};
</script>

<style>
trix-editor {
  @apply .border-gray-400 .p-4 .h-64 .overflow-y-auto;
}

.trix-button-row {
  @apply .overflow-x-auto;
}

.trix-button-row .trix-button-group--file-tools {
  @apply .hidden;
}

.trix-button-row .trix-button--icon-code {
  @apply .hidden;
}

trix-editor ul {
  @apply .list-disc;
}

trix-editor ol {
  @apply .list-decimal;
}

trix-editor strong {
  @apply .font-semibold;
}

trix-editor a {
  @apply .text-blue-500;
}

trix-editor a:hover {
  @apply .underline;
}
</style>